<template>
  <div class="row justify-content-md-center">
    <div class="col col-4">
      <h5>{{ $t("coupon.coupon") }}</h5>
    </div>
    <div class="col col-8">
      <div class="input-group input-group-sm" v-if="!code">
        <input type="text" v-model.lazy="code" class="form-control" :class="{'is-valid': valid === true, 'is-invalid': valid === false}">
        <div class="input-group-append">
          <button key="button-coupon" class="btn btn-primary" v-on:click="validate()">{{ $t("coupon.apply") }}</button>
        </div>
        <div class="valid-feedback" v-if="valid">
          {{ $t("coupon.valid") }}
        </div>
        <div class="invalid-feedback" v-else>
          {{ $t("coupon.invalid") }}
        </div>
      </div>
      <div class="active-coupon" v-if="code">
        <strong>
          {{code}}
          <i class="fa fa-check check"></i>
        </strong>
        <br>
        <span v-if="couponMaxPax">{{ $t("coupon.validFor") }} <strong>{{couponMaxPax}}  {{ $t("coupon.passengers") }}</strong></span>
        <span v-if="couponDescription"><br><strong>{{couponDescription}}</strong></span>
      </div>

    </div>
  </div>
</template>
<script>

import { mapMutations, mapState } from 'vuex';
export default {
  name: 'Coupon',
  data: () => {
    return {
      valid: null,
      codeVal: null,
    }
  },
  computed: {
    ...mapState(['form', 'couponMaxPax','couponDescription']),
    code: {
      get() {
        return this.form.coupon
      },
      set(value) {
        this.codeVal = value;
      }
    }
  },
  methods: {
    ...mapMutations(['couponCode']),
    validate(resolve) {
      if (this.codeVal !== null && this.codeVal !== '' && this.codeVal != this.code) {
        this.$http.get('coupons', {params: { code: this.codeVal}}).then((res) => {
          if (res.body) {
            this.valid = res.body.valid;
            if (this.valid) {
              this.couponCode({code: this.codeVal, maxPax: res.body.maxPax, description: res.body.description});
            }
            resolve && resolve();
          }
        });
      } else {
        resolve && resolve();
      }
    },
    validateFn() {
      return new Promise((resolve) => {
        return this.validate(resolve);
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .active-coupon{
    border: 2px solid whitesmoke;
  }

  .active-coupon i{
    color: green;
  }
</style>
